<template>
  <div class="modal show" tabindex="-1" role="dialog" id="modal_msg" style="display: block">
    <div class="modal-mask" @click.self="$emit('Modal', false)">
      <div class="modal-dialog modal-dialog-centered " role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Message</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Coming soon.</p>
          </div>
          <div class="modal-footer">
            <a href="#" class="btn btn-primary" data-dismiss="modal" @click="closeModal">OK</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closeModal () {
      this.$emit('asideModal', false)
    }
  }
}
</script>
